module.exports = __webpack_public_path__ + "static/scale-model-of-africa-tram-in-escondido-california-f0e8548faf10caefda0522c2de9907af.png";